import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { vhrpImages } from "@/lib/site";
import { LogIn, ArrowRight } from "lucide-react";

export default function Login() {
  const { user, loginWithGoogle } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();

  if (user) {
    navigate("/", { replace: true });
    return null;
  }

  return (
    <div className="relative flex min-h-[calc(100vh-4rem)] items-center justify-center overflow-hidden px-4 py-16">
      <img src={vhrpImages.banner} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(135deg, rgba(230,81,0,0.85), rgba(41,33,29,0.95))" }}
      />
      <div className="relative w-full max-w-md rounded-3xl border border-white/20 bg-white/95 p-8 text-center shadow-2xl backdrop-blur">
        <img src={vhrpImages.logoMark} alt="VHRP" className="mx-auto h-20 w-20 rounded-full ring-4 ring-brand-tint" />
        <h1 className="mt-5 text-2xl font-extrabold text-brand-dark">{t("orgName")}</h1>
        <p className="mt-1 text-sm font-semibold text-brand">{t("motto")}</p>
        <p className="mt-4 text-sm leading-relaxed text-ink-muted">{t("loginTagline")}</p>

        <Button
          data-testid="google-login-button"
          onClick={loginWithGoogle}
          className="mt-6 h-12 w-full rounded-full bg-brand text-base font-bold hover:bg-brand-dark"
        >
          <LogIn size={18} className="mr-2" /> {t("loginGoogle")}
        </Button>

        <button
          onClick={() => navigate("/membership")}
          data-testid="explore-plans-link"
          className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-brand hover:underline"
        >
          {t("memTitle")} <ArrowRight size={14} />
        </button>

        <p className="mt-6 text-xs leading-relaxed text-ink-muted">{t("loginLegal")}</p>
      </div>
    </div>
  );
}
